import 'jquery';
import 'owl.carousel';

export default {
  init() {
    this._initBSCarousel();
    this._initOwlCarousel();
  },

  finalize() {},

  _initBSCarousel() {
    if ('undefined' === typeof $.fn.carousel) {
      return;
    }

    const $carousels = $('.carousel');
    $carousels
      .not(':has(.carousel-item.active)')
      .find('.carousel-item:first-child')
      .addClass('active');

    $carousels.each((index, carousel) => {
      const $carousel = $(carousel);

      const hasVideos = !!$('.has-video, iframe[src*="vimeo.com"]', $carousel).length;
      if (hasVideos) {
        $carousel.carousel('pause');

        $('.carousel-item', $carousel).each((index, item) => {
          const $item = $(item);
          $item.data('video', $item.find('.video'));
        });
      }

      $carousel
        .on('slide.bs.carousel', data => {
          const $slide = $(data.relatedTarget);
          const $oldSlide = 'undefined' !== typeof data.from && $('.carousel-item', data.currentTarget).eq(data.from);

          // Previous slide had video.
          if ($oldSlide && $oldSlide.data('video')) {
            const player = $oldSlide.data('video').data('player');
            if (player) {
              player.pause().then(() => player.setCurrentTime(0));
            }
          }

          // This slide has video.
          if ($slide.data('video')) {
            const player = $slide.data('video').data('player');
            if (player) {
              player.setCurrentTime(0);
            }
          }
        })
        .on('slid.bs.carousel', data => {
          const $slide = $(data.relatedTarget);

          // This slide has video.
          if ($slide.data('video')) {
            const player = $slide.data('video').data('player');
            if (player) {
              player.play().then(() => $carousel.carousel('pause'));
            }
          }
        });
    });
  },

  _initOwlCarousel() {
    if ('undefined' === typeof $.fn.owlCarousel) {
      return;
    }
    $('.owl-carousel').each(function() {
      const $carousel = $(this);
      const settings = $carousel.data('owl-settings') || {};
      $carousel.owlCarousel(settings);
    });
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasCarousel.js